// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"4cd85a10","166":"6c3e4a19","346":"83c9fcd9","497":"c3246cd8","580":"05f1e676","663":"6dcec775","751":"fbfb0269","887":"3276de0b"}[chunkId] + ".chunk.css";
};